import { Component, ComponentFactoryResolver, Injector, Input, OnInit, ViewChild, ViewContainerRef } from '@angular/core';

@Component({
    selector: 'chassis-render, [chassis-render]',
    templateUrl: './render.component.html',
})
export class RenderComponent implements OnInit {

    @Input() component: any;

    @Input() data: { [key: string]: any } = {};

    @Input() injector: Injector;

    /**
     * The ViewContainerRef instance.
     */
    @ViewChild('content', { read: ViewContainerRef }) content: ViewContainerRef;

    /**
     * The rendered component instance.
     */
    protected contentInstance: any;

    constructor(private componentFactoryResolver: ComponentFactoryResolver) {
    }

    ngOnInit() {
        if (!this.component) {
            throw Error('No component was provided to render.');
        }

        this.renderContent();
    }

    protected renderContent() {
        const contentComponentFactory = this.componentFactoryResolver.resolveComponentFactory(this.component);

        const contentRef = this.content.createComponent(contentComponentFactory, null, this.injector || null);

        this.contentInstance = contentRef.instance;

        this.bindProperties();
    }

    /**
     * Create the data bindings.
     */
    protected bindProperties() {
        Object.keys(this.data).forEach((key) => {
            this.bindProperty(key);
        });
    }

    /**
     * Create an input binding.
     *
     * @param key
     */
    protected bindProperty(key) {
        this.contentInstance[ key ] = this.data[ key ];
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/support/render/components/render/render.component.ts